import React from "react";
import styled from "styled-components";
import { Avatar, Typography, Button } from "@ann/web-components";
import { useContactHeader } from "../../hooks/useContactHeader";

const HeaderScrolledContainer = styled.div`
  padding: 16px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  max-width: 1400px;
  width: 100%;
  align-self: center;

`;
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px; 
`;
export const HeaderScrolledLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding-left: 12px;
  padding-right: 12px;
`;
export const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const HeaderScrolledRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
`;


const HeaderScrolled = () => {
  const { contactDetails, loading, hasContact } = useContactHeader();

  if (!hasContact || !contactDetails || loading) {
    return null;
  }

  return (
    <HeaderScrolledContainer>
      <Container>
        <HeaderScrolledLeft>
          <Avatar size="xl"
            src="https://i.pravatar.cc/40" />
          <ProfileDetails>
            <Typography category='title' weight='bold' size='small' color='title'>
              {contactDetails.name}
            </Typography>
            <Typography category='body' weight='regular' size='small' color='body'>
              Last interaction: 3 days ago
            </Typography>
          </ProfileDetails>
        </HeaderScrolledLeft>
        <HeaderScrolledRight>
          {/* <Button size="small" type="secondary" icon="email" pill />
          <Button size="small" type="secondary" icon="sms" pill /> */}
          {/* Temporary disabled <Button size="small" type="secondary" icon="call" pill /> */}
        </HeaderScrolledRight>
      </Container>
    </HeaderScrolledContainer>
  );
};

export default HeaderScrolled;
